import styled from "styled-components";

import Button from "ds/Button";

export const AgreeWrapper = styled.div`
  margin-bottom: 40px;
  margin-top: 24px;
  .field {
    width: 264px;
  }
`;

export const DeactivateButton = styled(Button)`
  padding: 10px;
`;
